module.exports = __webpack_public_path__ + "img/battery_2default.eb9af813.png";